export default class Address {
    id!: string | null;
    city!: string | null;
    country!: string | null;
    email!: string | null;
    familyName!: string | null;
    givenName!: string | null;
    organizationName!: string | null;
    vatId!: string | null;
    customerId!: string | null;
    phone!: string | null;
    postalCode!: string | null;
    region!: string | null;
    streetAddress!: string | null;
    streetAddress2!: string | null;
    title!: string | null;
    isBusinessAddress!: boolean | null;

    constructor() {
        this.id = null;
        this.city = null;
        this.country = null;
        this.email = null;
        this.familyName = null;
        this.givenName = null;
        this.organizationName = null;
        this.vatId = null;
        this.customerId = null;
        this.phone = null;
        this.postalCode = null;
        this.region = null;
        this.streetAddress = null;
        this.streetAddress2 = null;
        this.title = null;
        this.isBusinessAddress = null;
    }
}
